export default __webpack_public_path__ + "static/media/Group3398.6c79eb0e.png";